export default function Hero() {
  const heroTextShadow = '0 2px 18px rgba(0,0,0,0.46), 0 1px 2px rgba(0,0,0,0.28)';
  const heroReadabilityMask = {
    background: [
      'radial-gradient(ellipse at 19% 74%, rgba(13,17,20,0.52) 0%, rgba(13,17,20,0.34) 23%, rgba(13,17,20,0.12) 43%, rgba(13,17,20,0) 62%)',
      'linear-gradient(0deg, rgba(13,17,20,0.24) 0%, rgba(13,17,20,0.09) 20%, rgba(13,17,20,0) 38%)',
    ].join(', '),
  };

  return (
    <section id="top" className="relative w-full h-[100svh] min-h-[640px] overflow-hidden">
      <img
        src="https://storage.helloreaddy.io/project_files/6010ef82-6c94-407b-9fac-7f3ca6010bf2/f0f81032-e12c-4ae5-9505-de34ac105393_compressed_sea-dreams-45.webp"
        alt="A refined luxury coastal property along the Emerald Coast at golden hour"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0" style={heroReadabilityMask} />

      <div className="relative z-10 h-full w-full max-w-[1400px] mx-auto px-5 md:px-10 flex flex-col justify-end pb-16 md:pb-24">
        <div className="max-w-4xl">
          <div
            className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.24em] text-background-100/90 mb-6 md:mb-8 animate-fade-up"
            style={{ textShadow: heroTextShadow }}
          >
            <span className="w-6 h-px bg-accent-500" />
            VACATIONS. INSPIRED. BY THE SEA.
          </div>

          <h1
            className="font-heading font-normal text-background-50 text-[36px] leading-[1.06] sm:text-[43px] sm:leading-[1.08] md:text-[74px] md:leading-[1.08] tracking-normal animate-fade-up max-w-[980px]"
            style={{
              animationDelay: '80ms',
              textShadow: heroTextShadow,
              fontKerning: 'normal',
              fontFeatureSettings: '"kern" 1, "liga" 0, "clig" 0',
              fontVariantLigatures: 'none',
            }}
          >
            We&rsquo;ll help you <span className="whitespace-nowrap">find</span> the perfect place to stay on the Emerald Coast.
          </h1>

          <p
            className="mt-5 md:mt-6 font-heading text-background-100 text-[23px] md:text-[35px] leading-[1.14] italic font-normal animate-fade-up"
            style={{ animationDelay: '160ms', textShadow: heroTextShadow }}
          >
            Start with where you want to stay.
          </p>

          <div
            className="mt-10 md:mt-12 flex flex-col sm:flex-row gap-3 sm:gap-4 animate-fade-up"
            style={{ animationDelay: '240ms' }}
          >
            <a
              href="#guided"
              className="inline-flex items-center justify-center gap-2 px-6 py-4 rounded-lg bg-[#EFE4D6] text-foreground-950 text-sm font-medium cursor-pointer whitespace-nowrap shadow-[0_16px_34px_rgba(0,0,0,0.28)] hover:bg-[#E9DCCB] transition-colors"
            >
              Tell us about your trip
              <i className="ri-arrow-right-up-line" />
            </a>
            <a
              href="#featured"
              className="inline-flex items-center justify-center gap-2 px-6 py-4 rounded-lg bg-foreground-950 text-background-50 text-sm cursor-pointer whitespace-nowrap shadow-[0_14px_30px_rgba(0,0,0,0.24)] hover:bg-accent-600 transition-colors"
            >
              See the properties
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
